import { render, staticRenderFns } from "./OtimizadorData.vue?vue&type=template&id=b164ea34&scoped=true"
import script from "./OtimizadorData.vue?vue&type=script&lang=js"
export * from "./OtimizadorData.vue?vue&type=script&lang=js"
import style0 from "./OtimizadorData.vue?vue&type=style&index=0&id=b164ea34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b164ea34",
  null
  
)

export default component.exports